import { render, staticRenderFns } from "./ReportCustomers.vue?vue&type=template&id=ea31a7de"
import script from "./ReportCustomers.vue?vue&type=script&lang=js"
export * from "./ReportCustomers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports